import { render, staticRenderFns } from "./AudioFiles.vue?vue&type=template&id=3774be52&scoped=true"
import script from "./AudioFiles.vue?vue&type=script&lang=js"
export * from "./AudioFiles.vue?vue&type=script&lang=js"
import style0 from "./AudioFiles.vue?vue&type=style&index=0&id=3774be52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3774be52",
  null
  
)

export default component.exports